export default __webpack_public_path__ + "static/media/l_11.ac49cb61.jpg";